import { UrlService } from "../../../core/services/UrlService";

export default ({ nav }) => {
    return {
        "id": "health",
        "name": "健康學堂",
        "style": "dropdown-columns",
        "children": [
            {
                "style": "prefix-button-with-icon",
                "children": [
                    {
                        "id": "btn-health-guides",
                        "name": "健康學堂",
                        "href": "https://www.finddoc.com/health",
                        "imgsrc": UrlService.getImageUrl('logo-bg-content-site.png'),
                    }
                ]
            },
            {
                "style": "multiple-rows",
                "children": [
                    {
                        "id": "health-guides",
                        "name": "專家與指南",
                        "children": [
                            {
                                "id": "finddoctv",
                                "name": "FindDocTV",
                                "href": "https://www.finddoc.com/health/finddoctv/"
                            },
                            {
                                "id": "guides",
                                "name": "健康指南",
                                "href": "https://www.finddoc.com/health/guides/"
                            },
                            {
                                "id": "doctors-blog",
                                "name": "醫生話你知",
                                "href": "https://www.finddoc.com/health/doctors-blog/"
                            },
                            {
                                "id": "news",
                                "name": "最新內容",
                                "href": "https://www.finddoc.com/health/news/"
                            }
                        ]
                    },
                    {
                        "id": "hot-topics",
                        "name": "熱門話題",
                        "sameColumn": true,
                        "children": [
                            {
                                "id": "cancer",
                                "name": "對抗癌症",
                                "href": "https://www.finddoc.com/health/%e5%b0%8d%e6%8a%97%e7%99%8c%e7%97%87/"
                            },
                            {
                                "id": "baby",
                                "name": "懷孕育兒",
                                "href": "https://www.finddoc.com/health/%e6%87%b7%e5%ad%95%e8%82%b2%e5%85%92/"
                            },
                            {
                                "id": "sex",
                                "name": "兩性健康",
                                "href": "https://www.finddoc.com/health/%e5%85%a9%e6%80%a7%e5%81%a5%e5%ba%b7/"
                            },
                            {
                                "id": "healthy",
                                "name": "吃出健康",
                                "href": "https://www.finddoc.com/health/%e5%90%83%e5%87%ba%e5%81%a5%e5%ba%b7/"
                            },
                            {
                                "id": "sport",
                                "name": "運動/物理治療",
                                "href": "https://www.finddoc.com/health/%e9%81%8b%e5%8b%95%e5%8f%8a%e7%89%a9%e7%90%86%e6%b2%bb%e7%99%82/"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "specialties",
                "name": "醫療分科",
                "children": [
                    {
                        "id": "obstetrician-gynecologist",
                        "name": "婦產科",
                        "href": "https://www.finddoc.com/health/%e9%86%ab%e7%99%82%e5%88%86%e7%a7%91/%e5%a9%a6%e7%94%a2%e7%a7%91/"
                    },
                    {
                        "id": "paediatrics",
                        "name": "兒科",
                        "href": "https://www.finddoc.com/health/%e9%86%ab%e7%99%82%e5%88%86%e7%a7%91/%e5%85%92%e7%a7%91/"
                    },
                    {
                        "id": "dermatologist-venereologist",
                        "name": "皮膚及性病科",
                        "href": "https://www.finddoc.com/health/%e9%86%ab%e7%99%82%e5%88%86%e7%a7%91/%e7%9a%ae%e8%86%9a%e5%8f%8a%e6%80%a7%e7%97%85%e7%a7%91/"
                    },
                    {
                        "id": "oncology",
                        "name": "腫瘤科",
                        "href": "https://www.finddoc.com/health/%e9%86%ab%e7%99%82%e5%88%86%e7%a7%91/%e8%85%ab%e7%98%a4%e7%a7%91/"
                    },
                    {
                        "id": "otorhinolaryngologist",
                        "name": "耳鼻喉科",
                        "href": "https://www.finddoc.com/health/%e9%86%ab%e7%99%82%e5%88%86%e7%a7%91/%e8%80%b3%e9%bc%bb%e5%96%89%e7%a7%91/"
                    },
                    {
                        "id": "gastroenterology-hepatology",
                        "name": "腸胃肝臟科",
                        "href": "https://www.finddoc.com/health/%e9%86%ab%e7%99%82%e5%88%86%e7%a7%91/%e8%85%b8%e8%83%83%e8%82%9d%e8%87%9f%e7%a7%91/"
                    },
                    {
                        "id": "view-all",
                        "name": "檢視全部",
                        "href": "https://www.finddoc.com/health/%e9%86%ab%e7%99%82%e5%88%86%e7%a7%91/"
                    }
                ]
            },
            {
                "id": "self-tests",
                "name": "健康小測試",
                "children": nav?.selfTests ?? [],
            },
            {
                "id": "latest_posts",
                "name": "最新健康資訊",
                "style": "gallery",
                "children": [
                    {
                        "id": "gallery-1",
                        "name": "鼻敏感、濕疹、哮喘互相有關係嗎？",
                        "href": "https://www.finddoc.com/health/finddoctv/%e6%bf%95%e7%96%b9%e8%88%87%e9%81%8e%e6%95%8f/",
                        "imgsrc": 'https://d1odbeb14fc0ti.cloudfront.net/wp-content/uploads/2021/08/26084128/16X9_TC-1-400x225.jpg',
                        "meta": {
                            "post-id": 21495,
                            "post-type": "finddoctv",
                            "position": "latest_news_header_nav",
                        }
                    },
                    {
                        "id": "gallery-2",
                        "name": "如何運用微創手術幫助靜脈曲張患者？",
                        "href": "https://www.finddoc.com/health/finddoctv/%e5%a6%82%e4%bd%95%e5%86%b6%e7%99%82%e9%9d%9c%e8%84%88%e6%9b%b2%e5%bc%b5%ef%bc%9f/",
                        "imgsrc": 'https://d1odbeb14fc0ti.cloudfront.net/wp-content/uploads/2021/08/17223837/16X9_TC-400x225.jpg',
                        "meta": {
                            "post-id": 21436,
                            "post-type": "finddoctv",
                            "position": "latest_news_header_nav",
                        }
                    },
                    {
                        "id": "gallery-liver-cancer",
                        "name": "肝癌初期症狀難察覺 死亡率卻超10% 標靶藥物助縮小腫瘤",
                        "href": "https://www.finddoc.com/health/guides/liver-cancer/",
                        "imgsrc": 'https://d1odbeb14fc0ti.cloudfront.net/wp-content/uploads/2021/06/11105635/%E8%82%9D%E7%99%8C%E5%88%9D%E6%9C%9F%E7%97%87%E7%8B%80%E9%9B%A3%E5%AF%9F%E8%A6%BA-400x210.jpg',
                        "meta": {
                            "post-id": 21270,
                            "post-type": "finddoctv",
                            "position": "latest_news_header_nav",
                        }
                    }
                ]
            },
        ]
    }
};